export const NAVBAR_HEADER_HEIGHT = 64;
